import Navbar from './Navbar';
import Footer from './Footer';

const BADGE_STYLES = {
  cyan:   'bg-[#00E5FF]/10 text-[#00E5FF] border border-[#00E5FF]/20',
  purple: 'bg-[#7C3AED]/10 text-[#7C3AED] border border-[#7C3AED]/20',
  amber:  'bg-amber-500/10 text-amber-400 border border-amber-500/20',
  green:  'bg-green-500/10 text-green-400 border border-green-500/20',
  red:    'bg-red-500/10 text-red-400 border border-red-500/20',
};

const GLOW_STYLES = {
  cyan:   'from-[#00E5FF]/10 via-transparent to-transparent',
  purple: 'from-[#7C3AED]/10 via-transparent to-transparent',
  amber:  'from-amber-500/10 via-transparent to-transparent',
  green:  'from-green-500/10 via-transparent to-transparent',
  red:    'from-red-500/10 via-transparent to-transparent',
};

export default function PageLayout({
  badge,
  badgeColor = 'cyan',
  title,
  subtitle,
  children,
}) {
  const badgeStyle = BADGE_STYLES[badgeColor] || BADGE_STYLES.cyan;
  const glowStyle  = GLOW_STYLES[badgeColor]  || GLOW_STYLES.cyan;

  return (
    <div className="min-h-screen bg-[#080c16] flex flex-col">
      <Navbar />

      {/* Hero band */}
      <div className="relative pt-32 pb-16 px-5 sm:px-8 overflow-hidden">
        {/* Gradient glow */}
        <div className={`absolute inset-0 bg-gradient-to-b ${glowStyle} pointer-events-none`} />

        <div className="max-w-6xl mx-auto relative z-10">
          {badge && (
            <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold mb-4 ${badgeStyle}`}>
              {badge}
            </span>
          )}
          {title && (
            <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2">{title}</h1>
          )}
          {subtitle && (
            <p className="text-slate-500 text-sm">{subtitle}</p>
          )}
        </div>
      </div>

      {/* Page content */}
      <div className="flex-1">
        {children}
      </div>

      <Footer />
    </div>
  );
}
